export default __webpack_public_path__ + "static/media/01-rock-sx.132444ae.png";